import React from 'react'
import {
  Typography,
  CircularProgress,
  Pagination,
  Box
} from '@mui/material'
import { PositionCard } from 'components'
import {
  type Position, type PositionFilterResults
} from 'services'

interface PositionsStackProps {
  orgId?: number
  personId?: number
  loading: boolean
  positions: PositionFilterResults
  triggerReload: () => Promise<void>
  changePage: (page: number) => Promise<void>
}

export const PositionsList: React.FC<PositionsStackProps> = ({
  orgId,
  personId,
  loading,
  positions,
  triggerReload,
  changePage
}) => {
  const renderCard = (
    item: Position,
    index: number,
    key: string
  ): React.ReactNode => {
    return (
        <PositionCard
            key={key}
            index={index}
            createCard={false}
            originalPosition={item}
            triggerReload={triggerReload}
            displayOrgLink={personId != null}
        />
    )
  }

  if (loading) { return <CircularProgress sx={{ alignSelf: 'center', mb: 3 }} /> }

  return (
      <React.Fragment>
        {positions.data.length === 0 && (
            <Typography>No Positions to Show</Typography>
        )}
          <Box display="flex" justifyContent="center">
              <Pagination count={positions.total_pages} page={positions.page_number} onChange={(event, page) => { void changePage(page) }} />
          </Box>
        {positions.data.map((item, index) => renderCard(item, index, `position-card-${item.id}`))}
        <Box mt={2} display="flex" justifyContent="center">
          <Pagination count={positions.total_pages} page={positions.page_number} onChange={(event, page) => { void changePage(page) }} />
        </Box>
      </React.Fragment>
  )
}
